import CircularProgress from '@mui/material/CircularProgress';

import PropTypes from 'prop-types';

/**
 * Loading stand-in for a number. The spinner takes the colour the value itself
 * would have been, so the card still reads as its own — and sits in a box the
 * size of the value's line box, so nothing moves when the number arrives.
 */
function ValueSpinner({ color, size, boxHeight }: any) {
    return (
        <span
            data-testid='value-spinner'
            style={{
                display: 'inline-flex',
                alignItems: 'center',
                justifyContent: 'center',
                height: boxHeight ?? size,
                minWidth: size,
                verticalAlign: 'middle',
            }}
        >
            <CircularProgress size={size} thickness={4} sx={{ color }} />
        </span>
    );
}

ValueSpinner.propTypes = {
    color: PropTypes.string.isRequired,
    size: PropTypes.number.isRequired,
    boxHeight: PropTypes.number,
};

export default ValueSpinner;
